import { Button } from "react-bootstrap";
import { faEnvelope, faPen, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Avatar from "react-avatar";
import EmailAttendeeModal from "./EmailUserModal";

const SpeakersList = (props) => {
  const { doctor, index } = props;
  return (
    <div className="col-md-6 mb-3 col-12 " key={index}>
      <div className="icon-box bg-dark rounded text-light shadow-sm w-100 h-100 px-4 py-3">
        <div className="d-flex align-items-center">
          <div className="mr-2 font-weight-bold">{index + 1}.</div>
          <div>
            <Avatar
              name={doctor.first_name + doctor.last_name}
              src={doctor.img_src}
              round={true}
              size="40"
              textSizeRatio={1.75}
              className="mr-3"
            />
          </div>
          <div className="flex-grow-1">
            <h3 className="text-s-10 mb-0 text-capitalize">
              {doctor.first_name + " " + doctor.last_name}
            </h3>
            <p className="small mb-0">{doctor.designation}</p>
            <p className="small font-weight-bold mb-0">{doctor.organisation}</p>
          </div>
        </div>
        <div className="d-flex flex-column align-items-center mt-3">
          <div className="d-flex w-100 ">
            {/* {!doctor.is_published && doctor.email_address ? (
              <Button
                variant="outline"
                className="btn-sm btn-outline-secondary mr-2"
                onClick={(e) => {
                  e.stopPropagation();
                  props.sendReminder(doctor.email_address);
                }}
              >
                <FontAwesomeIcon icon={faEnvelope} size="sm" />{" "}
                <span>Send reminder</span>
              </Button>
            ) : null} */}
            {doctor.email_address ? (
              <EmailAttendeeModal
                first_name={doctor.first_name}
                last_name={doctor.last_name}
                email_address={doctor.email_address}
              />
            ) : null}
            <Button
              onClick={() => props.speakerOnClickHandler(doctor)}
              variant="outline"
              className="btn-sm btn-outline-primary mr-2"
            >
              <FontAwesomeIcon icon={faPen} size="sm" />{" "}
              <span>Edit profile</span>
            </Button>
            {/* {doctor.is_published ? (
              <div>
                <Button
                  variant="outline"
                  className="btn-sm btn-outline-warning mr-2"
                  onClick={() => props.unPublishSpeakerHandler(doctor.id)}
                >
                  Unpublish
                </Button>
              </div>
            ) : (
              <div>
                <Button
                  variant="outline"
                  className="btn-sm btn-outline-warning mr-2"
                  onClick={() => props.publishSpeakerHandler(doctor.id)}
                >
                  Publish
                </Button>
              </div>
            )} */}
            <Button
              variant="outline"
              className="btn-sm btn-outline-danger mr-2"
              onClick={() => {
                props.setSelectedUID(doctor.id);
                props.setDeleteWarningModal(true);
              }}
            >
              <FontAwesomeIcon icon={faTrash} size="sm" /> <span>Delete</span>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default SpeakersList;
